module.exports = __webpack_public_path__ + "static/media/kolorowanka_8.aca11c03.png";